import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';

import { commonStyles } from '../../../styles/styles';

import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import DatePicker from '../DatePicker';
import Dropdown from '../Dropdown';





const FirstPage = ({ classes, form, nextPage,skipPages, onSubmitCoach,login, ...props }) => {
  const { handleSubmit, hadleSubmit2, checkCode} = props;
  const checkboxValue =
    form.registration && form.registration.values && form.registration.values.AmLeader;
    
    if(checkCode.codeMessage){
      console.log('SHORT REG', login)
      if(!checkCode.codeMessage.message && login.fetching==false ){
       if(checkCode.codeMessage.qualification==true  && !form.registration.values.AmLeader){
      
        onSubmitCoach()
       }else{
        onSubmitCoach()
       }
       
        return null
      }
     
    }
  return (
    <form className="w-100" onSubmit={handleSubmit}>
      <MDBCol md="12">
        <MDBRow>
          <MDBCol md="6">
          <Field name="firstname" label="First name" component={TextField}  />
          </MDBCol>
          <MDBCol md="6">
          <Field name="lastname" label="Last name" component={TextField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="12">
          <Field name="email" label="Email Address" component={EmailField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
          <Field name="cell" label="Cell Number" component={TextField}  />
          </MDBCol>
          <MDBCol md="6">
          <Field name="identityNo" label="ID Number" component={TextField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="12">
            {/* <label style={{float:'left',color: '#757575', position: 'relative',marginTop: '1.9rem',marginBottom: '2rem',marginRight: 10,marginBottom: '0.5rem'}}  htmlFor="exampleFormControlTextarea1">Date of Birth</label> */}
            <div style={{float:'left'}}>
            <Field name="birthdate" label="Date of Birth" component={DatePicker}  />
            </div>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="12">
          <Field name="programCode" label="Project Code" component={PasswordField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
          <Field name="password" label="Password" component={PasswordField}  />
          </MDBCol>
          <MDBCol md="6">
          <Field name="ConfirmPassword" label="Confirm Password" component={PasswordField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow md="12">
                  <MDBCol lg="10" className="w-100">
                    <Field name="CoachCode" type="password" label="Coach Code" id={Date.now().toString()} component={PasswordField} />
                  </MDBCol>
                </MDBRow>
        <MDBRow style={{textAlign:'right'}} className="mt-2">
        <MDBCol md="3" className="offset-md-9">
          <MDBBtn color="success"
              right
              size="md"
              className='ml-3 ml-4 mt-0 mb-2 float-right'
              action
              type="submit">
            SUBMIT
          </MDBBtn>
        </MDBCol>
        </MDBRow>
      </MDBCol>
    </form>
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}></h4>
    
      
    //   <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="firstname" label="First name" component={TextField}  />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="lastname" label="Surname" component={TextField} />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="cell" label="Cell" component={TextField}  />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="identityNo" label="ID Number" component={TextField}  />
    //     </div>
    //     <div className={classes.rowWrapper}>
    //       <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //         <Field
    //           name="programCode"
    //           component={ProjectCodeField}
    //           label="Program Code"
    //           confirmButton={false}
            
    //         />
    //       </div>
    //       <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //         <Field name="email" label="Email" component={EmailField}/>
    //       </div>
          
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field
    //         name="password"
    //         component={PasswordField}
    //         label="Password"
    //         id="adornment-password"
          
    //       />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field
    //         name="ConfirmPassword"
    //         component={PasswordField}
    //         label="Confirm Password"
    //         id="confirm-adornment-password"
           
    //       />
    //     </div>
        
    //     <div className={`${classes.halfField} ${classes.noTopLabel}`}>
    //       <Field
    //         name="AmLeader"
    //         component={RenderCheckbox}
    //         label=""
    //         checkedStatus={checkboxValue}
    //       />
    //     </div>
          
        
    //     <div>
    //       <button variant="contained"
    //         className={`${classes.defaultButton} ${classes.shortButton}`} type="submit">Next</button>
    //     </div>
     
    // </div>
  ) 
}



FirstPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});
const mapStateToProps = state => ({
  form: state.form,
  checkCode: state.checkCodeReducer,
  login: state.loginReducer,
});

export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
connect(mapStateToProps, null),
withStyles(styles),
)(FirstPage);



// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationSteps/FirstPage.js